import { render } from "./InventoryPorAtributo.vue?vue&type=template&id=00714b6f"
import script from "./InventoryPorAtributo.vue?vue&type=script&lang=js"
export * from "./InventoryPorAtributo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__